import Cookies from 'js-cookie';
import axios from 'axios';

function initCookies(settings) {
    Cookies.initialBackupLoadedKey = 'IsInitialBackupLoaded';
    Cookies.extraLongExpiration = 365000;
    Cookies.cookiesCheckUrl = settings.getBackupCookiesUrl;
    Cookies.backupCookiesUrl = settings.backupCookiesUrl;
    Cookies.isDashboard = settings.isDashboard;
}

Cookies.setWithSameSite = function(name, value, options) {
    if (!options || !options.sameSite) {
        const sameSiteOptions = {sameSite: 'Lax'};
        options = options ? Object.assign(options, sameSiteOptions): sameSiteOptions;
    }

    this.set(name, value, options);
};

Cookies.setWithBackupAsync = function(name, value, options) {
    this.setWithSameSite(name, value, options);
    const that = this;
    return new Promise((resolve) => {
        if (name) {
            axios.post(that.backupCookiesUrl, {name, value, options, isDashboard: that.isDashboard})
                .then(() => {
                    resolve();
                    // successfully backed up
                })
                .catch((e) => {
                    resolve();
                    // not backed up - but it should not be a problem for user
                });
        } else {
            resolve();
        }
    });
};

Cookies.getWithBackupCheckAsync = function(key) {
    const that = this;
    return new Promise((resolve) => {
        let result = this.get(key);

        if (result) {
            resolve(result);
        } else {
            this.loadBackupCookiesAsync()
                .then(() => {
                    result = that.get(key);
                    resolve(result);
                })
                .catch(() => {
                    resolve(result);
                });
        }
    });
};

Cookies.loadBackupCookiesAsync = function() {
    const that = this;
    this.loadCookiesPromise = this.loadCookiesPromise || new Promise((resolve) => {
        if (this.get(that.initialBackupLoadedKey)) {
            resolve();
        } else {
            axios.get(that.cookiesCheckUrl, {timeout: 5000})
                .then((res) => {
                    for (const cookieRecord of res.data) {
                        that.setWithSameSite(cookieRecord.name, cookieRecord.value, cookieRecord.options);
                    }

                    that.setWithSameSite(that.initialBackupLoadedKey, 'true', {expires: that.extraLongExpiration});
                    that.loadCookiesPromise = null;
                    resolve();
                })
                .catch(() => {
                    that.loadCookiesPromise = null;
                    resolve();
                });
        }
    });

    return this.loadCookiesPromise;
};

export {
    initCookies,
    Cookies,
};
